import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const contentContainer: SxStyle = {
  px: 4.5,
  py: 2,
};
